export const getters = {
    getModulesLabels(state, getters, rootState) {
        return state.modulesLabels;
    },
};

export default getters;
